require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

parcelRequire = function (e, r, n, t) {
  function i(n, t) {
    function o(e) {
      return i(o.resolve(e));
    }

    function c(r) {
      return e[n][1][r] || r;
    }

    if (!r[n]) {
      if (!e[n]) {
        var l = "function" == typeof parcelRequire && parcelRequire;
        if (!t && l) return l(n, !0);
        if (u) return u(n, !0);
        if (f && "string" == typeof n) return f(n);
        var p = new Error("Cannot find module '" + n + "'");
        throw p.code = "MODULE_NOT_FOUND", p;
      }

      o.resolve = c;
      var a = r[n] = new i.Module(n);
      e[n][0].call(a.exports, o, a, a.exports, this);
    }

    return r[n].exports;
  }

  function o(e) {
    this.id = e, this.bundle = i, this.exports = {};
  }

  var u = "function" == typeof parcelRequire && parcelRequire,
      f = "function" == typeof require && require;
  i.isParcelRequire = !0, i.Module = o, i.modules = e, i.cache = r, i.parent = u;

  for (var c = 0; c < n.length; c++) {
    i(n[c]);
  }

  if (n.length) {
    var l = i(n[n.length - 1]);
    "object" == typeof exports && "undefined" != typeof module ? module.exports = l : "function" == typeof define && define.amd ? define(function () {
      return l;
    }) : t && (this[t] = l);
  }

  return i;
}({
  23: [function (require, module, exports) {
    "use strict";

    var r = Object.getOwnPropertySymbols,
        t = Object.prototype.hasOwnProperty,
        e = Object.prototype.propertyIsEnumerable;

    function n(r) {
      if (null === r || void 0 === r) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(r);
    }

    function o() {
      try {
        if (!Object.assign) return !1;
        var r = new String("abc");
        if (r[5] = "de", "5" === Object.getOwnPropertyNames(r)[0]) return !1;

        for (var t = {}, e = 0; e < 10; e++) {
          t["_" + String.fromCharCode(e)] = e;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (r) {
          return t[r];
        }).join("")) return !1;
        var n = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (r) {
          n[r] = r;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
      } catch (r) {
        return !1;
      }
    }

    module.exports = o() ? Object.assign : function (o, c) {
      for (var a, i, s = n(o), f = 1; f < arguments.length; f++) {
        for (var u in a = Object(arguments[f])) {
          t.call(a, u) && (s[u] = a[u]);
        }

        if (r) {
          i = r(a);

          for (var b = 0; b < i.length; b++) {
            e.call(a, i[b]) && (s[i[b]] = a[i[b]]);
          }
        }
      }

      return s;
    };
  }, {}],
  13: [function (require, module, exports) {
    "use strict";

    var e = require("object-assign"),
        r = "function" == typeof Symbol && Symbol["for"],
        t = r ? Symbol["for"]("react.element") : 60103,
        n = r ? Symbol["for"]("react.portal") : 60106,
        o = r ? Symbol["for"]("react.fragment") : 60107,
        u = r ? Symbol["for"]("react.strict_mode") : 60108,
        l = r ? Symbol["for"]("react.profiler") : 60114,
        i = r ? Symbol["for"]("react.provider") : 60109,
        c = r ? Symbol["for"]("react.context") : 60110,
        f = r ? Symbol["for"]("react.async_mode") : 60111,
        a = r ? Symbol["for"]("react.forward_ref") : 60112;

    r && Symbol["for"]("react.placeholder");
    var p = "function" == typeof Symbol && Symbol.iterator;

    function s(e, r, t, n, o, u, l, i) {
      if (!e) {
        if (e = void 0, void 0 === r) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [t, n, o, u, l, i],
              f = 0;
          (e = Error(r.replace(/%s/g, function () {
            return c[f++];
          }))).name = "Invariant Violation";
        }
        throw e.framesToPop = 1, e;
      }
    }

    function y(e) {
      for (var r = arguments.length - 1, t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 0; n < r; n++) {
        t += "&args[]=" + encodeURIComponent(arguments[n + 1]);
      }

      s(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", t);
    }

    var d = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        v = {};

    function h(e, r, t) {
      this.props = e, this.context = r, this.refs = v, this.updater = t || d;
    }

    function m() {}

    function b(e, r, t) {
      this.props = e, this.context = r, this.refs = v, this.updater = t || d;
    }

    h.prototype.isReactComponent = {}, h.prototype.setState = function (e, r) {
      "object" != typeof e && "function" != typeof e && null != e && y("85"), this.updater.enqueueSetState(this, e, r, "setState");
    }, h.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, m.prototype = h.prototype;

    var _ = b.prototype = new m();

    _.constructor = b, e(_, h.prototype), _.isPureReactComponent = !0;
    var S = {
      current: null,
      currentDispatcher: null
    },
        g = Object.prototype.hasOwnProperty,
        k = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function $(e, r, n) {
      var o = void 0,
          u = {},
          l = null,
          i = null;
      if (null != r) for (o in void 0 !== r.ref && (i = r.ref), void 0 !== r.key && (l = "" + r.key), r) {
        g.call(r, o) && !k.hasOwnProperty(o) && (u[o] = r[o]);
      }
      var c = arguments.length - 2;
      if (1 === c) u.children = n;else if (1 < c) {
        for (var f = Array(c), a = 0; a < c; a++) {
          f[a] = arguments[a + 2];
        }

        u.children = f;
      }
      if (e && e.defaultProps) for (o in c = e.defaultProps) {
        void 0 === u[o] && (u[o] = c[o]);
      }
      return {
        $$typeof: t,
        type: e,
        key: l,
        ref: i,
        props: u,
        _owner: S.current
      };
    }

    function w(e, r) {
      return {
        $$typeof: t,
        type: e.type,
        key: r,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }

    function x(e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }

    function P(e) {
      var r = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return r[e];
      });
    }

    var j = /\/+/g,
        C = [];

    function E(e, r, t, n) {
      if (C.length) {
        var o = C.pop();
        return o.result = e, o.keyPrefix = r, o.func = t, o.context = n, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: r,
        func: t,
        context: n,
        count: 0
      };
    }

    function R(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > C.length && C.push(e);
    }

    function O(e, r, o, u) {
      var l = typeof e;
      "undefined" !== l && "boolean" !== l || (e = null);
      var i = !1;
      if (null === e) i = !0;else switch (l) {
        case "string":
        case "number":
          i = !0;
          break;

        case "object":
          switch (e.$$typeof) {
            case t:
            case n:
              i = !0;
          }

      }
      if (i) return o(u, e, "" === r ? "." + U(e, 0) : r), 1;
      if (i = 0, r = "" === r ? "." : r + ":", Array.isArray(e)) for (var c = 0; c < e.length; c++) {
        var f = r + U(l = e[c], c);
        i += O(l, f, o, u);
      } else if (null === e || "object" != typeof e ? f = null : f = "function" == typeof (f = p && e[p] || e["@@iterator"]) ? f : null, "function" == typeof f) for (e = f.call(e), c = 0; !(l = e.next()).done;) {
        i += O(l = l.value, f = r + U(l, c++), o, u);
      } else "object" === l && y("31", "[object Object]" === (o = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : o, "");
      return i;
    }

    function A(e, r, t) {
      return null == e ? 0 : O(e, "", r, t);
    }

    function U(e, r) {
      return "object" == typeof e && null !== e && null != e.key ? P(e.key) : r.toString(36);
    }

    function q(e, r) {
      e.func.call(e.context, r, e.count++);
    }

    function F(e, r, t) {
      var n = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, r, e.count++), Array.isArray(e) ? I(e, n, t, function (e) {
        return e;
      }) : null != e && (x(e) && (e = w(e, o + (!e.key || r && r.key === e.key ? "" : ("" + e.key).replace(j, "$&/") + "/") + t)), n.push(e));
    }

    function I(e, r, t, n, o) {
      var u = "";
      null != t && (u = ("" + t).replace(j, "$&/") + "/"), A(e, F, r = E(r, u, n, o)), R(r);
    }

    function M(e, r) {
      var t = S.currentDispatcher;
      return null === t && y("277"), t.readContext(e, r);
    }

    var D = {
      Children: {
        map: function map(e, r, t) {
          if (null == e) return e;
          var n = [];
          return I(e, n, null, r, t), n;
        },
        forEach: function forEach(e, r, t) {
          if (null == e) return e;
          A(e, q, r = E(null, null, r, t)), R(r);
        },
        count: function count(e) {
          return A(e, function () {
            return null;
          }, null);
        },
        toArray: function toArray(e) {
          var r = [];
          return I(e, r, null, function (e) {
            return e;
          }), r;
        },
        only: function only(e) {
          return x(e) || y("143"), e;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: h,
      PureComponent: b,
      createContext: function createContext(e, r) {
        return void 0 === r && (r = null), (e = {
          $$typeof: c,
          _calculateChangedBits: r,
          _currentValue: e,
          _currentValue2: e,
          Provider: null,
          Consumer: null,
          unstable_read: null
        }).Provider = {
          $$typeof: i,
          _context: e
        }, e.Consumer = e, e.unstable_read = M.bind(null, e), e;
      },
      forwardRef: function forwardRef(e) {
        return {
          $$typeof: a,
          render: e
        };
      },
      Fragment: o,
      StrictMode: u,
      unstable_AsyncMode: f,
      unstable_Profiler: l,
      createElement: $,
      cloneElement: function cloneElement(r, n, o) {
        (null === r || void 0 === r) && y("267", r);
        var u = void 0,
            l = e({}, r.props),
            i = r.key,
            c = r.ref,
            f = r._owner;

        if (null != n) {
          void 0 !== n.ref && (c = n.ref, f = S.current), void 0 !== n.key && (i = "" + n.key);
          var a = void 0;

          for (u in r.type && r.type.defaultProps && (a = r.type.defaultProps), n) {
            g.call(n, u) && !k.hasOwnProperty(u) && (l[u] = void 0 === n[u] && void 0 !== a ? a[u] : n[u]);
          }
        }

        if (1 === (u = arguments.length - 2)) l.children = o;else if (1 < u) {
          a = Array(u);

          for (var p = 0; p < u; p++) {
            a[p] = arguments[p + 2];
          }

          l.children = a;
        }
        return {
          $$typeof: t,
          type: r.type,
          key: i,
          ref: c,
          props: l,
          _owner: f
        };
      },
      createFactory: function createFactory(e) {
        var r = $.bind(null, e);
        return r.type = e, r;
      },
      isValidElement: x,
      version: "16.5.2",
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentOwner: S,
        assign: e
      }
    },
        T = {
      "default": D
    },
        V = T && D || T;
    module.exports = V["default"] || V;
  }, {
    "object-assign": 23
  }],
  9: [function (require, module, exports) {
    "use strict";

    module.exports = require("./cjs/react.production.min.js");
  }, {
    "./cjs/react.production.min.js": 13
  }],
  19: [function (require, module, exports) {
    "use strict";

    function t(t) {
      return function () {
        return t;
      };
    }

    var n = function n() {};

    n.thatReturns = t, n.thatReturnsFalse = t(!1), n.thatReturnsTrue = t(!0), n.thatReturnsNull = t(null), n.thatReturnsThis = function () {
      return this;
    }, n.thatReturnsArgument = function (t) {
      return t;
    }, module.exports = n;
  }, {}],
  20: [function (require, module, exports) {
    "use strict";

    var e = function e(_e) {};

    function n(n, r, i, o, t, a, f, s) {
      if (e(r), !n) {
        var u;
        if (void 0 === r) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var d = [i, o, t, a, f, s],
              l = 0;
          (u = new Error(r.replace(/%s/g, function () {
            return d[l++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    }

    module.exports = n;
  }, {}],
  17: [function (require, module, exports) {
    "use strict";

    var _ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = _;
  }, {}],
  14: [function (require, module, exports) {
    "use strict";

    var e = require("fbjs/lib/emptyFunction"),
        r = require("fbjs/lib/invariant"),
        t = require("./lib/ReactPropTypesSecret");

    module.exports = function () {
      function o(e, o, p, n, s, a) {
        a !== t && r(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function p() {
        return o;
      }

      o.isRequired = o;
      var n = {
        array: o,
        bool: o,
        func: o,
        number: o,
        object: o,
        string: o,
        symbol: o,
        any: o,
        arrayOf: p,
        element: o,
        instanceOf: p,
        node: o,
        objectOf: p,
        oneOf: p,
        oneOfType: p,
        shape: p,
        exact: p
      };
      return n.checkPropTypes = e, n.PropTypes = n, n;
    };
  }, {
    "fbjs/lib/emptyFunction": 19,
    "fbjs/lib/invariant": 20,
    "./lib/ReactPropTypesSecret": 17
  }],
  10: [function (require, module, exports) {
    var r, e, i;
    module.exports = require("./factoryWithThrowingShims")();
  }, {
    "./factoryWithThrowingShims": 14
  }],
  6: [function (require, module, exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var e = exports.EMBED_URL = "https://public-assets.typeform.com/confab/embed.js";
  }, {}],
  5: [function (require, module, exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    }), exports.scriptTagExists = exports.getScriptTags = void 0;

    var t = require("./constants"),
        e = exports.getScriptTags = function (e) {
      var r = e.document.getElementsByTagName("head")[0].childNodes;
      return [].filter.call(r, function (e) {
        return e.src === t.EMBED_URL;
      });
    },
        r = exports.scriptTagExists = function (t) {
      var r = t.document;
      return !!e({
        document: r
      }).length;
    };
  }, {
    "./constants": 6
  }],
  3: [function (require, module, exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var e = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        t = require("react"),
        r = o(t),
        n = require("prop-types"),
        i = o(n),
        u = require("./utils"),
        a = require("./constants");

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function c(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function s(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function f(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var l = function (n) {
      function i() {
        c(this, i);
        var e = s(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this));
        return e.ref = (0, t.createRef)(), e;
      }

      return f(i, t.Component), e(i, [{
        key: "componentDidMount",
        value: function value() {
          if ((0, u.scriptTagExists)({
            document: document
          })) window.__CUI && window.__CUI.register(this.ref.current);else {
            var e = document.createElement("script");
            e.type = "text/javascript", e.id = "cui-embed-script", e.src = a.EMBED_URL, e.async = !0, document.head.appendChild(e);
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              n = e.uid,
              i = e.height,
              u = e.avatar,
              a = e.theme;
          return r["default"].createElement(t.Fragment, null, n ? r["default"].createElement("div", {
            key: "cui-" + n,
            className: "cui-embed",
            "data-cui-uid": n,
            "data-cui-height": i,
            "data-cui-avatar": u,
            "data-cui-theme": a,
            ref: this.ref
          }) : null);
        }
      }]), i;
    }();

    l.propTypes = {
      uid: i["default"].string.isRequired,
      height: i["default"].oneOfType([i["default"].string, i["default"].number]),
      avatar: i["default"].string,
      theme: i["default"].string
    }, exports["default"] = l;
  }, {
    "react": 9,
    "prop-types": 10,
    "./utils": 5,
    "./constants": 6
  }],
  1: [function (require, module, exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: !0
    });

    var e = require("./react-cui");

    function t(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    Object.defineProperty(exports, "default", {
      enumerable: !0,
      get: function get() {
        return t(e)["default"];
      }
    });
  }, {
    "./react-cui": 3
  }]
}, {}, [1], null);